module.exports = __webpack_public_path__ + "static/media/Season.0cd94128.svg";